import type { SlideVisibility } from '../../../constants';
import { SLIDE_HIDDEN } from '../../../constants';

export const visibilityToQuestionSkipSlide = (
  visibility: SlideVisibility,
): boolean => {
  return visibility === SLIDE_HIDDEN;
};
